var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _g, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _circle, _circle2, _circle3, _path41, _rect2, _path42, _circle4, _circle5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#494949;}.cls-2{fill:#121212;}.cls-3{fill:#e4c5ff;}.cls-4{fill:#599bff;}.cls-5{fill:#1b6eff;}.cls-6{fill:#589bff;}.cls-7{fill:#989898;}.cls-8{fill:#adadad;}.cls-9{fill:#7c7c7c;}.cls-10{fill:#fff;}.cls-11{fill:#666;}.cls-12{fill:#004472;}.cls-13{clip-path:url(#clip-path);}.cls-14{fill:#aeaeae;}.cls-15{fill:#979797;}.cls-16{fill:#fbb3ff;}.cls-17{fill:#cbcbcb;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.2,126.26c-.31-6.6-.82-10.8-.82-12.9a11.63,11.63,0,0,1,.94-5H99.51l-6.05,12.24a25.36,25.36,0,0,0-6.92-4.18h0l.62,3.75a8.56,8.56,0,0,1-.93,5.44,6.51,6.51,0,0,1-6.12,3.59c-4.7,0-9-5.55-15.31-10.28-6.25,4.72-10.61,10.28-15.3,10.28h0a6.44,6.44,0,0,1-6.29-7.82l1.28-5.9A35.38,35.38,0,0,0,26.57,126.7a73.42,73.42,0,0,0,79.95,49.84c15.85-6.53,19.93-22.34,19.93-39.82C126.45,132.72,126.34,129.24,126.2,126.26Z"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Batch3_sourcefiles_v1_5B_uploadvideo_dark") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 200,
    height: 200
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M191.71,78.65V94a7,7,0,1,1-14,0V78.65a7,7,0,1,1,14,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M177.26,71.63h7.44a7,7,0,0,0-7,7V94a7,7,0,0,0,7,7H177a7,7,0,0,1-7-7V78.65a7,7,0,0,1,7-7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M169.51,71.63H177a7,7,0,0,0-7,7V94a7,7,0,0,0,7,7h-7.44a7,7,0,0,1-6.65-4.77A7.31,7.31,0,0,1,162.5,94V78.65a7.26,7.26,0,0,1,.36-2.25,7.11,7.11,0,0,1,3.69-4.12A7,7,0,0,1,169.51,71.63Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M169.56,101.05q.06,1.42.06,2.88a73,73,0,0,1-13.48,42.37l-8.4-27.22H149v-5.91a5.44,5.44,0,0,0,5-5.43V106.1h3.28a10.42,10.42,0,0,0,9.3-5.71,7,7,0,0,0,3,.66Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M166.55,72.28a7.11,7.11,0,0,0-3.69,4.12H156.8V96.28h6.06a7.06,7.06,0,0,0,3.69,4.11,10.42,10.42,0,0,1-9.3,5.71H142a10.45,10.45,0,0,0,10.44-10.44V77A10.44,10.44,0,0,0,142,66.58h15.23a10.45,10.45,0,0,1,9.3,5.7Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M162.86,76.4h0a7.26,7.26,0,0,0-.36,2.25V94a7.31,7.31,0,0,0,.36,2.25H156.8V76.4Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.29,63.22c.79,1.18,1.55,2.39,2.27,3.62a10.35,10.35,0,0,0-2.31-.26H153V63.22Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M147.74,119.08l8.4,27.22a71.75,71.75,0,0,1-7,8.41l-2.36-7.63-4.61-14.93-4-13.07Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M154,106.1v1.64a5.44,5.44,0,0,1-5,5.43l-.44,0h-12a4.41,4.41,0,0,1-.52,0,5.44,5.44,0,0,1-4.94-5.42V106.1H154Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M153,63.22v3.36H139.73V47.67H153V51h-3.13a6.1,6.1,0,1,0,0,12.19Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M172.14,51H149.85a6.1,6.1,0,1,0,0,12.19h22.29a6.1,6.1,0,0,0,0-12.19Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.82,147.08l2.36,7.63c-.77.8-1.55,1.59-2.36,2.35Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M146.82,147.08v10a72.39,72.39,0,0,1-9,7.29h0v-18l4.37-14.15Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M138.17,119.08l4,13.07-4.37,14.15L131,168.55a72.52,72.52,0,0,1-11,4.81l16.77-54.28Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M138.29,93.67a4.24,4.24,0,0,1,1.59,3.56c0,6.31-7.72,4.91-11.89,8.87h0a7.61,7.61,0,0,0-1.66,2.31H99.51l5.85-11.85a33.65,33.65,0,0,1,12-14.67c4.61-3.16,9.42-4.79,13-4.79,4.26,0,7.65,2,7.65,5.53a7.41,7.41,0,0,1-.65,2.86,4.61,4.61,0,0,1,2.41,4.24v0A6.24,6.24,0,0,1,138.29,93.67Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M139.73,47.67V66.58h-8.29a4.51,4.51,0,0,1-4.51-4.51V52.18a4.51,4.51,0,0,1,4.51-4.51Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M137.84,164.35h0a73.71,73.71,0,0,1-6.87,4.2l6.87-22.25Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.2,126.26c-.31-6.6-.82-10.8-.82-12.9a11.63,11.63,0,0,1,.94-5A7.61,7.61,0,0,1,128,106.1h3.12v1.64a5.44,5.44,0,0,0,4.94,5.42h0v5.91h.65l-16.77,54.28a72.08,72.08,0,0,1-13.4,3.18c15.85-6.53,19.93-22.34,19.93-39.82C126.45,132.72,126.34,129.24,126.2,126.26Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M136,119.08v-5.91h0a4.41,4.41,0,0,0,.52,0h12l.44,0v5.91H136Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.2,126.26c-.31-6.6-.82-10.8-.82-12.9a11.63,11.63,0,0,1,.94-5H99.51l-6.05,12.24a25.36,25.36,0,0,0-6.92-4.18h0l.62,3.75a8.56,8.56,0,0,1-.93,5.44,6.51,6.51,0,0,1-6.12,3.59c-4.7,0-9-5.55-15.31-10.28-6.25,4.72-10.61,10.28-15.3,10.28h0a6.44,6.44,0,0,1-6.29-7.82l1.28-5.9A35.38,35.38,0,0,0,26.57,126.7a73.42,73.42,0,0,0,79.95,49.84c15.85-6.53,19.93-22.34,19.93-39.82C126.45,132.72,126.34,129.24,126.2,126.26Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M101.44,47.36a26.38,26.38,0,0,1,.53,5.35,35.61,35.61,0,0,1-1.92,11.19h-.9A6.92,6.92,0,0,1,93.83,57C93.83,52.48,97.51,47.84,101.44,47.36Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M101.06,45.75c.14.53.28,1.07.38,1.61-3.93.48-7.61,5.12-7.61,9.61a6.92,6.92,0,0,0,5.32,6.92H97.49c-7,0-10-4.51-10-8.35,0-5.11,5-10.07,11.1-10.07A11.45,11.45,0,0,1,101.06,45.75Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M98.78,30.64a8.57,8.57,0,0,1,.14,1.51,12.38,12.38,0,0,1-1.55,6.28h0A19.58,19.58,0,0,1,99,40.85a20.87,20.87,0,0,1,2.06,4.9c.14.53.28,1.07.38,1.61a26.38,26.38,0,0,1,.53,5.35,35.61,35.61,0,0,1-1.92,11.19,1.27,1.27,0,0,0-.06.18h0c-.23.7-.49,1.4-.77,2.09h0c3.78,0,5.62,2.12,5.62,4.32s-1.63,4.23-4.8,4.75c.13,1.16.28,2.33.44,3.51H93.63a10.66,10.66,0,0,0,7.49,4.66,67.14,67.14,0,0,1,.6,8.23c0,13.22-6.44,18.91-16.08,19.33h0l.28,1.69.62,3.81h0a25.36,25.36,0,0,1,6.92,4.18l6.05-12.24,5.85-11.85a33.65,33.65,0,0,1,12-14.67V66.58h14a4.51,4.51,0,0,1-4.51-4.51V52.18a4.51,4.51,0,0,1,4.51-4.51h11.89A73,73,0,0,0,98.78,30.64Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M27.08,79.65a42.34,42.34,0,0,0,7.13,15A59.21,59.21,0,0,0,40,101.5a73.86,73.86,0,0,0,6.22,5.59h0l0,0c6.82-3.43,13.1-8.12,15.07-15.3C53,87.65,50.49,81.6,50.49,76.49c0-6.7,4.45-10.47,9.42-10.47,3.64,0,6.15,2,8,4.82a67.19,67.19,0,0,0,3.35-11.5c5-2.31,9.12-6.46,9.12-12.44a15.68,15.68,0,0,0-2.55-8.47H97.37a12.38,12.38,0,0,0,1.55-6.28,8.57,8.57,0,0,0-.14-1.51c-.87-4.8-5.74-9.11-12.24-9.11-9.85,0-20.11,8.16-28.45,8.16a19.06,19.06,0,0,1-5.57-.76,19.49,19.49,0,0,0,1.08,4.3A17.59,17.59,0,0,0,38.91,44.94C30.12,49.31,26,59,26,69.86a44,44,0,0,0,.5,6.63c.16,1.07.36,2.12.61,3.16"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M87.16,120.22a8.56,8.56,0,0,1-.93,5.44,6.51,6.51,0,0,1-6.12,3.59c-4.7,0-9-5.55-15.31-10.28,4.63-3.5,10.31-6.55,17.94-6.55a21.28,21.28,0,0,1,3.18.24l.62,3.81Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M64.8,119c-6.25,4.72-10.61,10.28-15.3,10.28h0a6.44,6.44,0,0,1-6.29-7.82l1.28-5.9.66-3c.58,0,1.16-.07,1.74-.07C54.5,112.42,60.17,115.47,64.8,119Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M46.3,107.07v.06l0,0Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.29,107.13l-1.17,5.36-.66,3A35.38,35.38,0,0,0,26.57,126.7a73.79,73.79,0,0,1,.51-47,42.34,42.34,0,0,0,7.13,15A59.21,59.21,0,0,0,40,101.5a73.86,73.86,0,0,0,6.22,5.59h0Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M126.2,126.26c-.31-6.6-.82-10.8-.82-12.9a11.63,11.63,0,0,1,.94-5H99.51l-6.05,12.24a25.36,25.36,0,0,0-6.92-4.18h0l.62,3.75a8.56,8.56,0,0,1-.93,5.44,6.51,6.51,0,0,1-6.12,3.59c-4.7,0-9-5.55-15.31-10.28-6.25,4.72-10.61,10.28-15.3,10.28h0a6.44,6.44,0,0,1-6.29-7.82l1.28-5.9A35.38,35.38,0,0,0,26.57,126.7a73.42,73.42,0,0,0,79.95,49.84c15.85-6.53,19.93-22.34,19.93-39.82C126.45,132.72,126.34,129.24,126.2,126.26Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 38.91,
    y: 153.26,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 38.91,
    y: 122.88,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 99.67,
    y: 122.88,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 99.67,
    y: 153.26,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 69.29,
    y: 122.88,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 69.29,
    y: 153.26,
    width: 14.74,
    height: 15.64
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 53.65,
    y: 108.15,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 84.03,
    y: 108.15,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 23.27,
    y: 108.15,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 114.4,
    y: 108.15,
    width: 18.46,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38.91,
    y: 108.15,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.67,
    y: 108.15,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    x: 69.29,
    y: 108.15,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 114.4,
    y: 138.52,
    width: 18.46,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 23.27,
    y: 138.52,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 53.65,
    y: 138.52,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 84.03,
    y: 138.52,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 38.91,
    y: 138.52,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.67,
    y: 138.52,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69.29,
    y: 138.52,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 84.03,
    y: 168.9,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 53.65,
    y: 168.9,
    width: 15.64,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 99.67,
    y: 168.9,
    width: 14.74,
    height: 14.74
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 69.29,
    y: 168.9,
    width: 14.74,
    height: 14.74
  }))), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M77.38,164.19a.69.69,0,0,1-.5-.21C66.47,153.56,59,147.74,42.38,140.74a.71.71,0,0,1,.55-1.31c16.41,6.9,24,12.68,34.12,22.72l.43-1.43c3.23-10.6,8.62-28.35,17.62-46.81a.71.71,0,1,1,1.28.62c-8.95,18.36-14.33,36-17.54,46.6-.28.9-.54,1.76-.78,2.56a.71.71,0,0,1-.51.48Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M140.72,100.42h-.15a.71.71,0,0,1-.55-.84,9.12,9.12,0,0,0,.16-1.1c.42-5-4-5.79-5.34-5.91-4.71-.39-8.67,2.32-10,5.07a.7.7,0,0,1-1,.32.69.69,0,0,1-.32-.94c2.07-4.25,7.42-6.19,11.4-5.86,4.45.38,7,3.23,6.63,7.44a9.55,9.55,0,0,1-.18,1.26A.7.7,0,0,1,140.72,100.42Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M143,93.7a.7.7,0,0,1-.69-.56c-1-4.92-2-7.31-6.81-8-4-.56-8.75,1.22-10.94,4.15a.72.72,0,0,1-1,.14.71.71,0,0,1-.14-1c2.48-3.31,7.76-5.33,12.27-4.71,5.86.82,7,4.28,8,9.09a.7.7,0,0,1-.55.84Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M76.52,55.84A8.07,8.07,0,0,0,70.1,53c-1.73,0-3.56.3-5.28.3-4.83,0-6.42-2.67-6.42-7.41,0-.54,0-1.07,0-1.6,0-3.78-1-6.65-5.37-6.65-2.34,0-4.78,1-7.18,1a6.34,6.34,0,0,1-2.61-.48,16.85,16.85,0,0,0-4.34,6.82c-7.93,4-12.09,12.25-12.82,21.78a26.53,26.53,0,0,1,5.34-1c9,0,1.23,17.14,14.28,17.14,1.94,0,4-.31,6-.42a15,15,0,0,1-1.2-5.9c0-6.7,4.45-10.47,9.42-10.47,3.64,0,6.15,2,8,4.82a67.19,67.19,0,0,0,3.35-11.5A18.69,18.69,0,0,0,76.52,55.84Z"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M42.73,72.41h-.08a.7.7,0,0,1-.62-.78c0-.24,0-.49,0-.74,0-2.22-2.06-10.5-8.24-10.5a23.25,23.25,0,0,0-6.66,1.42.72.72,0,0,1-.89-.46.7.7,0,0,1,.46-.89A24.2,24.2,0,0,1,33.83,59c7.34,0,9.65,9.3,9.65,11.92a6.55,6.55,0,0,1,0,.89A.7.7,0,0,1,42.73,72.41Z"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M69.78,64.7c-8.32,0-12.5-5.54-15.85-10-2.43-3.22-4.53-6-7.52-6a5.38,5.38,0,0,0-1.12.11A.71.71,0,1,1,45,47.43a7.36,7.36,0,0,1,1.39-.14c3.69,0,6.1,3.19,8.65,6.57,3.39,4.5,7.24,9.6,15.15,9.42a.71.71,0,1,1,0,1.42Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M53.36,69.43a.68.68,0,0,1-.51-.22A23.43,23.43,0,0,1,49,63.5c-1.43-2.7-2.32-4.23-4.17-4.23a2.17,2.17,0,0,0-.66.11.72.72,0,0,1-.89-.48.71.71,0,0,1,.48-.88,3.56,3.56,0,0,1,1.07-.16c2.79,0,4,2.3,5.42,5a22.47,22.47,0,0,0,3.59,5.39.71.71,0,0,1,0,1A.69.69,0,0,1,53.36,69.43Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M85,39.14l-.15,0a.69.69,0,0,1-.54-.84,8.76,8.76,0,0,0,.2-1.79,6.84,6.84,0,0,0-2.35-5.12.71.71,0,1,1,1-1,8.2,8.2,0,0,1,2.8,6.15,9.58,9.58,0,0,1-.24,2.09A.71.71,0,0,1,85,39.14Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M92,39.14l-.17,0a.72.72,0,0,1-.52-.86,8.76,8.76,0,0,0,.28-2.15,5.46,5.46,0,0,0-2.12-4.51.71.71,0,1,1,.88-1.11A6.89,6.89,0,0,1,93,36.11a10.57,10.57,0,0,1-.32,2.49A.71.71,0,0,1,92,39.14Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.86,70.49c0-2.2-1.84-4.32-5.62-4.32h0c.28-.69.54-1.39.77-2.09h0a1.27,1.27,0,0,1,.06-.18H97.49c-7,0-10-4.51-10-8.35,0-5.11,5-10.07,11.1-10.07a11.45,11.45,0,0,1,2.43.27A20.87,20.87,0,0,0,99,40.85a19.58,19.58,0,0,0-1.66-2.42H77.88a15.68,15.68,0,0,1,2.55,8.47c0,6-4.13,10.13-9.12,12.44A67.19,67.19,0,0,1,68,70.84C66.06,68,63.55,66,59.91,66c-5,0-9.42,3.77-9.42,10.47,0,5.11,2.52,11.16,10.88,15.28-2,7.18-8.25,11.87-15.07,15.3v.06l-1.17,5.36c.58,0,1.16-.07,1.74-.07,7.64,0,13.31,3,17.94,6.55,4.63-3.5,10.31-6.55,17.94-6.55a21.28,21.28,0,0,1,3.18.24L85.64,111h0c9.64-.42,16.08-6.11,16.08-19.33a67.14,67.14,0,0,0-.6-8.23,10.66,10.66,0,0,1-7.49-4.66h6.87c-.16-1.18-.31-2.35-.44-3.51C103.23,74.72,104.86,72.57,104.86,70.49Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M89.73,83.06a.72.72,0,0,1-.65-.42.71.71,0,0,1,.36-.94,5,5,0,0,0,3.27-4.6,5.9,5.9,0,0,0-.48-2.27.71.71,0,0,1,1.31-.54,7.34,7.34,0,0,1,.59,2.81A6.39,6.39,0,0,1,90,83,.59.59,0,0,1,89.73,83.06Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 81.47,
    cy: 71.87,
    r: 1.15
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 87.48,
    cy: 70.27,
    r: 1.15
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-9",
    cx: 87.32,
    cy: 76.73,
    r: 1.15
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M65.12,144.75a.7.7,0,0,1-.71-.7V119a.71.71,0,0,1,1.42,0v25.08A.7.7,0,0,1,65.12,144.75Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 123.77,
    y: 59.7,
    width: 6.48,
    height: 12.96,
    rx: 2.82
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.46,77V95.66A10.45,10.45,0,0,1,142,106.1H128c4.17-4,11.89-2.56,11.89-8.87a4.24,4.24,0,0,0-1.59-3.56,6.24,6.24,0,0,0,1.52-3.9v0a4.61,4.61,0,0,0-2.41-4.24,7.41,7.41,0,0,0,.65-2.86c0-3.53-3.39-5.53-7.65-5.53-3.59,0-8.4,1.63-13,4.79V66.58H142A10.44,10.44,0,0,1,152.46,77Z"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-17",
    cx: 124.07,
    cy: 72.23,
    r: 1.89
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 132.8,
    cy: 72.23,
    r: 1.89
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyProfile);
export default __webpack_public_path__ + "static/media/empty-profile.ac448e48e42632bfbc285a15ee740f4a.svg";
export { ForwardRef as ReactComponent };